<template>
  <div
    v-if="saleBadge"
    class="product-sale-badge"
  >
    {{ saleBadge }}
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useProductStore } from '../../pinia/ProductStore'

export default {
  computed: {
    ...mapState (useProductStore, ['saleBadge'])
  },
}
</script>
